import { NgModule } from "@angular/core";
import { AllMaterialModule } from "../all-material.components";
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CoreModule } from "../core/core.module";
import { FlexLayoutModule } from "@angular/flex-layout";
import { UIRouterModule } from "@uirouter/angular";

import { Breadcrumb } from "./breadcrumb.component";
import { List } from "./list.component";
import { ConfirmDialog } from "./confirm-dialog.component";
import { ListMapping } from "./list-mapping.component";
import { HierarchicalListMapping } from "./hierarchical-list-mapping.component";

import { DatePipe } from '@angular/common';
import { CrewDatePipe } from "./crew-date.pipe";
import { CrewDateWithLocalTimezonePipe } from "./crew-date-with-local-timezone.pipe";
import { CrewEncodeURIComponent } from "./crew-encodeURIComponent.pipe";
import { Principal } from "./auth/principal.service";
import { AuthServerProvider } from "./auth/auth.service";
import { LoginService } from "./auth/login.service";
import { CrewEventManager } from "./event-manager.service";
import { SecurePipe } from "./secure.pipe";
import { Auth401Service } from "./auth/auth401.service";
import { SnackBarService } from "./snackbar.service";
import { CrewErrorDialog } from "../core/crew-error-dialog.component";
import { AttachmentHandler } from "./attachment-handler.component";
import { NestedListItem } from "./nested-list-item.component";
import { NestedList } from "./nested-list.component";
import { SearchableNestedList } from "./searchable-nested-list.component";
import { CrewOkDialog } from "./crew-ok-dialog.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        AllMaterialModule,
        UIRouterModule,
        CoreModule,
        FlexLayoutModule
    ],
    providers: [
        DatePipe,
        AuthServerProvider,
        LoginService,
        Principal,
        CrewEventManager,
        CrewDatePipe,
        Auth401Service,
        SnackBarService
    ],
    declarations: [
        Breadcrumb,
        List,
        NestedList,
        SearchableNestedList,
        NestedListItem,
        ConfirmDialog,
        CrewErrorDialog,
        CrewOkDialog,
        AttachmentHandler,
        ListMapping,
        HierarchicalListMapping,
        CrewDatePipe,
        CrewDateWithLocalTimezonePipe,
        SecurePipe,
        CrewEncodeURIComponent
    ],
    exports: [
        Breadcrumb,
        List,
        NestedList,
        SearchableNestedList,
        NestedListItem,
        ConfirmDialog,
        CrewErrorDialog,
        CrewOkDialog,
        AttachmentHandler,
        ListMapping,
        HierarchicalListMapping,
        CrewDatePipe,
        CrewDateWithLocalTimezonePipe,
        SecurePipe,
        CrewEncodeURIComponent
    ],
    entryComponents: [CrewErrorDialog, NestedList, CrewOkDialog]
})
export default class SharedModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/shared.module.ts